import { useState } from "react";
import api from "../../api";
import { useToast } from "../ToastContext";

export interface AgendaDashboardType {
    id: number;
    description: string | null;
    instituicaoName: string | null;
    startDate: string | null;
    endDate: string | null;
    tipoAgendaName: string | null;
    cursoName: string | null;
}

export interface EmpresaDashboardType {
    contratosAbertos: number;
    contratosEmPreparacao: number;
    contratosFinalizados: number;
    totalAlunos: number;
    totalContaReceberPendente: number;
    totalContaPagarPendente: number;
    proximasAgendas: AgendaDashboardType[];
}

export default function useDashboard() {
    const showToast = useToast();
    const [empresaDashboard, setEmpresaDashboard] = useState<EmpresaDashboardType | null>(null);
    const [isDashboardLoading, setIsDashboardLoading] = useState(false);

    async function fetchEmpresaDashboard(empresaId: number): Promise<void> {
        setIsDashboardLoading(true);
        try {
            const { data } = await api.get<EmpresaDashboardType>(`/Dashboard/empresa?empresaId=${empresaId}`);
            setEmpresaDashboard(data);
        } catch {
            showToast("error", "Erro ao carregar dados do dashboard.");
        } finally {
            setIsDashboardLoading(false);
        }
    }

    return { empresaDashboard, isDashboardLoading, fetchEmpresaDashboard };
}
